import { PATH_CALL_CENTER, PATH_CALL_CENTER_CALL_LEAD, PATH_CALL_CENTER_JOIN } from "@/routes/paths";
import { useLocation } from "react-router-dom";
import MainCallCenterTopHeader from "./cc-top-header/main.top.header.cc";
import { useSidebar } from "@/components/ui/sidebar";
import { Menu as MobileMenuIcon } from "lucide-react";

// Agent in-call routes (video + voice) — join-meeting-as-admin keeps the
// header (its screen still uses the regular layout).
const IN_CALL_PREFIXES = [
  PATH_CALL_CENTER_JOIN.replace(":sessionName", ""),
  PATH_CALL_CENTER_CALL_LEAD.replace(":sessionName", ""),
];

const MainTopHeader: React.FC = () => {
  const location = useLocation();
  const { isMobile, toggleSidebar } = useSidebar();
  const isCallCenterPage = location.pathname.startsWith(PATH_CALL_CENTER);
  // The in-call screen is immersive (demo-ui session layout): no workspace
  // header, room selector or tabs while the agent is on a call. The layout
  // mounts CallCenterSelectionBootstrap to cover the header's data bootstrap.
  const isInCallPage = IN_CALL_PREFIXES.some((prefix) => location.pathname.startsWith(prefix));

  if (isInCallPage) return null;
  if (isCallCenterPage) return <MainCallCenterTopHeader />;

  return (
    <header className="w-full min-h-10 px-5 py-3 flex md:hidden items-center justify-between relative z-[50]">
      {isMobile && (
        <button
          type="button"
          className="cursor-pointer mr-3"
          onClick={toggleSidebar}
          aria-label="Toggle navigation menu"
        >
          <MobileMenuIcon />
        </button>
      )}
      <img className="max-w-[200px] opacity-100 mx-auto" src="/logos/ironpipeline.svg" alt="IronPipeline logo" />
    </header>
  );
};

export default MainTopHeader;
